import { createSlice } from '@reduxjs/toolkit';

const initialState = { name: 'light' };

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    set(state, action) {
      state.name = action.payload;
    },
  },
});

export { themeSlice };
export default themeSlice.reducer;
